(async () => {
    if (!customElements.get("powershot-reviews")) {
        class PowershotReviews extends HTMLElement {
            constructor() {
                
                

                super();
                this.swiperElement = this.querySelector("[data-powershot-reviews-slider-swiper]");
                this.swiperOptions = {
                    loop: true,
                    autoplay: false,
                    slidesPerView: 1,
                    observer: false,
                    threshold: 10,
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 0
                        }
                    }
                };
                if (this && this.dataset && this.dataset.options) {
                    const jsonOptions = JSON.parse(this.dataset.options);
                    if (jsonOptions) {
                        this.swiperOptions = {
                            ...this.swiperOptions,
                            ...jsonOptions
                        }
                    }
                }
                if (Shopify.designMode && this.swiperInstance) {
                    window.addEventListener("shopify:section:load", (() => {
                        this.swiperInstance.update()
                    }))
                }
                this.init()
            }
            init() {
                this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
                this.APP_KEY = "0MuaEO0P9jMkwfSreVIoqkgQkxyBZzF2QpSdUf5Z";
                this.SECRET_KEY = "N1VqtVmTfpFuRGGqsPrPNb1wtsdMdLjuh8KVMWEK";

                // this.getYotpoReviews();

            }
            getYotpoReviews() {
                const options = {
                    method: 'GET',
                    headers: {
                        accept: 'application/json',
                        'X-Yotpo-Token': '0MuaEO0P9jMkwfSreVIoqkgQkxyBZzF2QpSdUf5Z',
                        'Content-Type': 'application/json'
                    }
                };

                fetch('https://api.yotpo.com/v1/apps/0MuaEO0P9jMkwfSreVIoqkgQkxyBZzF2QpSdUf5Z/products/4798984814685/reviews?utoken=N1VqtVmTfpFuRGGqsPrPNb1wtsdMdLjuh8KVMWEK&count=5&page=1', options)
                .then(res => res.json())
                .then(res => console.log('res===========>',res))
                .catch(err => console.error(err));
            }
        }
        window.PowershotReviews = PowershotReviews;
        customElements.define("powershot-reviews", PowershotReviews)
    }
})();
